import { render, staticRenderFns } from "./seckill-time.vue?vue&type=template&id=297a033f&scoped=true"
import script from "./seckill-time.vue?vue&type=script&lang=js"
export * from "./seckill-time.vue?vue&type=script&lang=js"
import style0 from "./seckill-time.vue?vue&type=style&index=0&id=297a033f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297a033f",
  null
  
)

export default component.exports